import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus, faSearchMinus } from "@fortawesome/free-solid-svg-icons";

import "../style/Mybook.css";

const Zoom = ({ zoomLevel, setZoomLevel }) => {
  const handleZoomIn = () => {
    console.log("zoomin");
    console.log(zoomLevel);
    setZoomLevel((prevZoomLevel) => Math.min(prevZoomLevel + 0.4, 5));
  };

  const handleZoomOut = () => {
    console.log("zoomout");
    console.log(zoomLevel);
    setZoomLevel((prevZoomLevel) => Math.max(prevZoomLevel - 0.4, 0.4));
  };

  return (
    <div className="zoom-buttons">
      <button onClick={handleZoomIn}>
        <FontAwesomeIcon icon={faSearchPlus} />
      </button>
      <button onClick={handleZoomOut}>
        <FontAwesomeIcon icon={faSearchMinus} />
      </button>
    </div>
  );
};

export default Zoom;
